"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "villandro": {
    "9a18c14c": [{
      "hkey": "299c5f9c",
      "slug": "villandro",
      "name": "Villandro",
      "primary": true,
      "skipSearch": false
    }],
    "san-maurizio": [{
      "hkey": "299c5f9c",
      "slug": "villandro",
      "name": "Villandro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "be24ed10": [{
      "hkey": "299c5f9c",
      "slug": "villandro",
      "name": "Villandro",
      "primary": true,
      "skipSearch": false
    }],
    "san-valentino": [{
      "hkey": "299c5f9c",
      "slug": "villandro",
      "name": "Villandro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "de25fc6e": [{
      "hkey": "299c5f9c",
      "slug": "villandro",
      "name": "Villandro",
      "primary": true,
      "skipSearch": false
    }],
    "santo-stefano": [{
      "hkey": "299c5f9c",
      "slug": "villandro",
      "name": "Villandro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;